// routes/_app.market.submit.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.market.submit')

export const handle = { name: 'market/submit', showAppNav: true }

export default dynamic(getClientModule, { ssr: false })
